'use strict';exports.__esModule = true;exports.mapPropertyCommodities = exports.mapBuildingCommodities = undefined;var _intersection = require('lodash/intersection');var _intersection2 = _interopRequireDefault(_intersection);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var buildingCommodities = ['garbage_chute', 'gym', 'accessible', 'stroller_room'];

var propertyCommodities = ['air_conditioner', 'master_bedroom', 'renovation', 'shelter', 'warehouse', 'window_bars', 'furnished', 'roommates', 'pool'];

var mapBuildingCommodities = exports.mapBuildingCommodities = function mapBuildingCommodities(commodities) {return (0, _intersection2.default)(commodities, buildingCommodities);};

var mapPropertyCommodities = exports.mapPropertyCommodities = function mapPropertyCommodities(commodities) {return (0, _intersection2.default)(commodities, propertyCommodities);};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/commodities.js
// module id = 3073
// module chunks = 0